import { render, staticRenderFns } from "./Inventarios.vue?vue&type=template&id=3bfeb5a4"
import script from "./Inventarios.vue?vue&type=script&lang=js"
export * from "./Inventarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports